import { useNavigate } from "react-router-dom";
// import { bookPodWithPlan } from "../services/PodService";
import { toast } from "react-toastify";
import logo from "../style/images/blue-logo-without-tagline.svg";
import { bookPodWithPlan, verifyPayment } from "../services/PodService";

const useRazorpay = () => {
  const navigate = useNavigate();

  const displayRazorpay = async (
    selectedSlot: number,
    selectedPodId: string,
    data: any,
    userEmail: string
  ) => {
    try {
      // Create booking first
      const bookingData = {
        plan_id: data[selectedSlot]?.id,
        pod_id: selectedPodId,
        email: userEmail,
      };

      const bookingResponse = await bookPodWithPlan(bookingData);

      if (!bookingResponse.status.success) {
        toast.error(bookingResponse.status.errorMessage || "Booking failed");
        return;
      }

      const options = {
        timeout: 150,
        key: process.env.REACT_APP_RAZORPAY_KEY_ID as string,
        amount: data[selectedSlot]?.discounted_amount * 100,
        currency: "INR",
        name: "UrbanNaps",
        description: `Booking for ${data[selectedSlot]?.plan_name} for ${data[selectedSlot]?.duration} minutes`,
        image: { logo },
        order_id: bookingResponse.data?.booking.order_id,
        notes: {
          address: "UrbanNaps Corporate Office",
          booking_id: bookingResponse.data?.booking_id,
        },
        theme: {
          color: "#0E97E6",
        },
        prefill: {
          name: "UrbanNaps",
          email: userEmail,
          contact: "1234567890",
        },
        handler: async (response: any) => {
          // Verify payment with backend
          try {
            // Check if booking_id and order_id are available
            if (!bookingResponse.data?.booking_id || !bookingResponse.data?.booking.order_id) {
              toast.error("Missing booking information for payment verification");
              return;
            }
            
            const verificationData = {
              booking_id: bookingResponse.data.booking_id,
              order_id: response.razorpay_order_id,
              payment_id: response.razorpay_payment_id,
              signature: response.razorpay_signature
            };
            
            const verificationResponse = await verifyPayment(verificationData);
            
            if (!verificationResponse.status.success) {
              toast.error(verificationResponse.status.errorMessage || "Payment verification failed");
              return;
            }
            
            // Payment verified successfully
            if (selectedSlot !== null) {
              const bookingDetails = {
                ...bookingResponse.data,
                plan_name: data[selectedSlot]?.plan_name,
                pod_id: selectedPodId,
                payment_id: response.razorpay_payment_id,
                verified: true
              };
              localStorage.setItem("bookingDetails", JSON.stringify(bookingDetails));
              navigate("/thankyou");
              window.location.reload();
            }
          } catch (error) {
            console.error("Error verifying payment:", error);
            toast.error("Failed to verify payment. Please contact support.");
          }
        },
        modal: {
          ondismiss: () => {
            console.log("Checkout form closed");
          },
        },
      };


      // Initialize Razorpay
      const razorpay = new (window as any).Razorpay(options);

      razorpay.on("payment.failed", (response: any) => {
        console.error("Payment failed", response.error);

        //TODO: to be removed in future
        razorpay.close();
        toast.error("Payment Failed, redirected to bookings page temporarily");
        navigate("/bookings");
      });

      // Open Razorpay Checkout
      razorpay.open();
    } catch (error) {
      console.error("Error in payment process:", error);
      toast.error("An error occurred while processing payment");
    }
  };

  return { displayRazorpay };
};

export default useRazorpay;